/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';

import simcardStyle from 'assets/jss/adescom/adescomStyle';
import TariffsRange from 'components/Adescom/SimpleSelectRest';
import { SimCardEntity, SimCardStatus } from 'modules/simcard/Entity';
import { FormGeneralHelper } from 'helpers/FormGeneral';
import InputFormRest from 'components/Form/InputFormRest';
import IccidPoolChooseDialog from 'views/iccid-pools/Dialog/IccidPoolChooseDialog';
import ActionButton from '../../../components/Buttons/CustomTextButton';
import { simCardActions, simCardConstants } from '../../../modules/simcard/actions';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { SimCardMnoTariffLoader } from '../../../modules/tariffs/SimCardMnoTariffLoader';

class MsisdnIccidParring extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            entity: SimCardEntity,
            entityStatus: SimCardStatus,
            openIccid: false,
            showAccept: false,
            iccidItem: null,
            mvneOperators: null,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.simCardMnoTariffLoader = new SimCardMnoTariffLoader(this.itemLoader);
    }

    loadMvnoOperatorSetup = () => {
        const { iccidItem } = this.state;
        if (iccidItem) {
            this.simCardMnoTariffLoader.load({
                callback: () => {
                    this.setState({
                        mvneOperators: { 'hydra:member': this.simCardMnoTariffLoader.getHeaderList() },
                    });
                },
                orders: [{ name: 'displayName', value: 'asc' }],
                filters: [
                    { name: 'typeValue', value: 'TARIFF' },
                    { name: 'operatorType', value: iccidItem.operatorType },
                    { name: 'platformResellerId', value: iccidItem.ownerPlatformResellerId },
                ],
            });
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { iccidItem } = this.state;
        if (iccidItem !== prevState.iccidItem) {
            this.loadMvnoOperatorSetup();
        }
    }

    openGetIccid = () => {
        this.setState((prevState) => ({
            openIccid: true,
        }));
    };

    closeIccid = () => {
        this.setState((prevState) => ({
            openIccid: false,
        }));
    };

    callBackSetIccid = (value) => {
        let accept = false;
        if (this.state.entity.tariffPlanId) {
            accept = true;
        }
        this.setState(
            (prevState) => ({
                entity: {
                    ...prevState.entity,
                    iccid: value.item.iccid,
                    imsi: value.item.imsi,
                    msisdn: this.props.item.msisdn,
                },
                iccidItem: value.item,
                showAccept: accept,
            }),
            () => {
                this.closeIccid();
            }
        );
    };

    saveAndActivateSimCard = () => {
        const { dispatch } = this.props;
        const entity = SimCardEntity;
        entity.msisdn = this.state.entity.msisdn;
        entity.isPrepaid = false;
        if (this.state.entity.tariffPlanId) {
            const mvneOperatorSetup = this.simCardMnoTariffLoader.getItemById(this.state.entity.tariffPlanId);
            entity.tariffPlanId = mvneOperatorSetup.constName;
            entity.isPrepaid = mvneOperatorSetup.prepaid;
        }
        entity.iccid = this.state.entity.iccid;
        entity.imsi = this.state.entity.imsi;
        entity.isPorted = false;

        dispatch(
            simCardActions.post(
                FormGeneralHelper.getUrl('/sim_cards'),
                entity,
                simCardConstants.SIM_CARD_ADD,
                (data) => {
                    this.props.refreshPage(this.state.iccidItem);
                },
                { propagateDataToCallback: true }
            )
        );
    };

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    selectFunc = (e, stateName, require) => {
        const value = e.target.value;
        let accept = false;
        if (this.state.entity.imsi) {
            accept = true;
        }
        this.setState((prevState) => ({
            entity: {
                ...prevState.entity,
                [stateName]: value,
            },
            entityStatus: {
                ...prevState.entityStatus,
                [stateName]: null,
            },
            showAccept: accept,
        }));
    };

    render() {
        const { classes, item } = this.props;
        const { entity, entityStatus, showAccept, mvneOperators } = this.state;

        if (item) {
            return (
                <React.Fragment>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12}></GridItem>
                                        <GridItem xs={12}>
                                            <InputFormRest
                                                onClick={this.openGetIccid}
                                                classes={classes}
                                                callback={this.change}
                                                stateName="imsi"
                                                stateObjectState={entityStatus.imsi}
                                                typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                                typeField={FormGeneralHelper.TYPE_TEXT}
                                                displayFieldName="simcard:add.imsi"
                                                vMax={256}
                                                vMin={-1}
                                                required={true}
                                                value={entity.imsi}
                                                helpText="simcard:general.imsi"
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TariffsRange
                                                callback={this.selectFunc}
                                                restElements={mvneOperators}
                                                stateName="tariffPlanId"
                                                idState="tariffPlanId"
                                                idSelected={entity.tariffPlanId}
                                                propKey="value"
                                                required={true}
                                                propValue="name"
                                                emptyLabel="general:common.empty_label"
                                                label="pools:sim.service_profile"
                                            />
                                        </GridItem>
                                        {item.ported && <GridItem xs={12}></GridItem>}
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12}>
                            {showAccept && (
                                <ActionButton
                                    callback={this.saveAndActivateSimCard}
                                    callbackParam={{}}
                                    label="simcard:add.register_sim_card"
                                    size="sm"
                                />
                            )}
                        </GridItem>
                    </GridContainer>
                    <IccidPoolChooseDialog
                        platformResellerId={item.ownerPlatformResellerId}
                        callBackClose={this.closeIccid}
                        callBackSetIccid={this.callBackSetIccid}
                        open={this.state.openIccid}
                    />
                </React.Fragment>
            );
        } else {
            return <div>Loading...</div>;
        }
    }
}

MsisdnIccidParring.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(simcardStyle));
const Enhance = enhance(MsisdnIccidParring);
export default Enhance;
